import { render, staticRenderFns } from "./edit-popup.vue?vue&type=template&id=3646cb5e&scoped=true&"
import script from "./edit-popup.vue?vue&type=script&lang=ts&"
export * from "./edit-popup.vue?vue&type=script&lang=ts&"
import style0 from "./edit-popup.vue?vue&type=style&index=0&id=3646cb5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3646cb5e",
  null
  
)

export default component.exports